// extracted by css-extract-rspack-plugin
export default {"close":"close-M2gLP9"};